import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { Coord } from "../types/Interface";
import getAngleBetweenPoints from "../utils/getAngleBtwPoints";
import getCenterOfTwoCoords from "../utils/getCenterOfTwoCoords";


export default class Line extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  private w = 5;
  private lineColor: number;
  private equelSymbol = false;
  constructor(details?: { width?: number, color?: number, equelSymbol?: boolean }) {
    super();
    this.w = details && details.width ? details.width : 5;
    this.lineColor = details && details.color ? details.color : 0x000000;
    this.equelSymbol = details?.equelSymbol || false;
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Middle.addChild(this);
  setLineColor = (color: number) => this.lineColor = color;

  draw(coordStart: Coord, coordEnd: Coord) {
    this.clear();

    this.moveTo(coordStart.x, coordStart.y)
      .lineTo(coordEnd.x, coordEnd.y)
      .stroke({ color: this.lineColor, width: this.w });

    if (this.equelSymbol) {
      const coords = getEquelLineCoords(coordStart, coordEnd);
      this.moveTo(coords[0].x, coords[0].y)
        .lineTo(coords[1].x, coords[1].y)
        .stroke({ color: this.lineColor, width: this.w - 2 })
    }
  }
}

function getEquelLineCoords(coordStart: Coord, coordEnd: Coord) {
  const length = 18
  const radian = getAngleBetweenPoints(coordStart, coordEnd) + Math.PI / 2;
  const centerCoord = getCenterOfTwoCoords(coordStart, coordEnd);
  const coord1 = {
    x: Math.cos(radian) * (length / 2) + centerCoord.x,
    y: Math.sin(radian) * (length / 2) + centerCoord.y
  }
  const coord2 = {
    x: Math.cos(radian) * (-length / 2) + centerCoord.x,
    y: Math.sin(radian) * (-length / 2) + centerCoord.y
  }
  return [coord1, coord2];
}